// @flow
import React from 'react';
import { makeStyles, Divider, IconButton, Dialog, DialogTitle, Box, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { getAvatar } from '../../newsfeedHelpers';
import { CustomAvatar } from '../common';

const useStyles = makeStyles(theme => ({
  list: {
    padding: '15px',
    overflowY: 'auto',
    height: '30vh',
    [theme.breakpoints.down('sm')]: {
      height: '60vh'
    }
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
    top: 0
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: 'var(--colorDefault)'
  },
  name: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '19px',
    letterSpacing: '0px',
    textAlign: 'left',
    wordBreak: 'break-word'
  }
}));

const ClientsModal = ({ open, close, data }) => {
  const classes = useStyles();

  return (
    <>
      <Dialog maxWidth="sm" fullWidth open={open} onClose={close}>
        <DialogTitle style={{ position: 'relative' }} id="dialog-title">
          <Typography className={classes.title}>Clients</Typography>
          <IconButton className={classes.closeBtn} id="ModalHeaderButtonClose" onClick={close}>
            <CloseIcon style={{ fontSize: 25 }} />
          </IconButton>
        </DialogTitle>
        <Divider />
        <div className={classes.list}>
          {data.map(client => (
            <div key={client.id}>
              <Box display="flex" alignItems="center" px={{ xs: 0, md: 1 }} py={1}>
                <CustomAvatar>{getAvatar(client.name)}</CustomAvatar>
                <Box pl={{ xs: 1.2, md: 2 }} flexGrow={1}>
                  <Typography className={classes.name} variant="h4">
                    {client.name}
                  </Typography>
                </Box>
              </Box>
              <Divider />
            </div>
          ))}
        </div>
      </Dialog>
    </>
  );
};

export default React.memo(ClientsModal);
